import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl ml8 mt3 fs20 arial",
  style: {}
}, "Google", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl ml8 mt3 fs20 arial",
  style: {}
}, "iCal", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl ml8 mt3 fs20 arial",
  style: {}
}, [
  /*#__PURE__*/_createTextVNode(" Office365 "),
  /*#__PURE__*/_createElementVNode("i", { class: "grey fs11" }, "(online)")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl ml8 mt3 fs20 arial",
  style: {}
}, [
  /*#__PURE__*/_createTextVNode(" Outlook "),
  /*#__PURE__*/_createElementVNode("i", { class: "grey fs11" }, "(online)")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl ml8 mt3 fs20 arial",
  style: {}
}, "Outlook", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addEventToGoogleCalendar && _ctx.addEventToGoogleCalendar(...args))),
      class: _normalizeClass(`fs16 pointer fw600 pointer blueAround circle_button mb5 mr5 ${_ctx.isSP ? `w100` : `fl`}`),
      style: {"line-height":"50px","height":"50px"}
    }, [
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/logo/logo_google.png`),
        width: "20",
        height: "21",
        style: {},
        class: "fl mt4"
      }, null, 8, _hoisted_2),
      _hoisted_3,
      _hoisted_4
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addEventToiCalDL && _ctx.addEventToiCalDL(...args))),
      class: _normalizeClass(`fs16 pointer fw600 pointer blueAround circle_button mb5 mr5 ${_ctx.isSP ? `w100` : `fl`}`),
      style: {"line-height":"50px","height":"50px"}
    }, [
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/logo/logo_apple.png`),
        width: "17",
        height: "23",
        style: {},
        class: "fl mt2"
      }, null, 8, _hoisted_5),
      _hoisted_6,
      _hoisted_7
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addEventToO365Calendar && _ctx.addEventToO365Calendar(...args))),
      class: _normalizeClass(`fs16 pointer fw600 pointer blueAround circle_button mb5 mr5 ${_ctx.isSP ? `w100` : `fl`}`),
      style: {"line-height":"50px","height":"50px"}
    }, [
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/logo/logo_microsoft.png`),
        width: "18",
        height: "21",
        style: {},
        class: "fl mt4"
      }, null, 8, _hoisted_8),
      _hoisted_9,
      _hoisted_10
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addEventToOutlook && _ctx.addEventToOutlook(...args))),
      class: _normalizeClass(`fs16 pointer fw600 pointer blueAround circle_button mb5 mr5 ${_ctx.isSP ? `w100` : `fl`}`),
      style: {"line-height":"50px","height":"50px"}
    }, [
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/logo/logo_microsoft.png`),
        width: "18",
        height: "21",
        style: {},
        class: "fl mt4"
      }, null, 8, _hoisted_11),
      _hoisted_12,
      _hoisted_13
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addEventToOutlookDL && _ctx.addEventToOutlookDL(...args))),
      class: _normalizeClass(`fs16 pointer fw600 pointer blueAround circle_button mb5 mr5 ${_ctx.isSP ? `w100` : `fl`}`),
      style: {"line-height":"50px","height":"50px"}
    }, [
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/logo/logo_microsoft.png`),
        width: "18",
        height: "21",
        style: {},
        class: "fl mt4"
      }, null, 8, _hoisted_14),
      _hoisted_15,
      _hoisted_16
    ], 2)
  ]))
}